import { InjectionToken } from '@angular/core';

export const RMA_META_PIXEL_ID = new InjectionToken<string>('Rma.Tracking.MetaPixel');
